// extracted by mini-css-extract-plugin
export var aside = "aside-panel-module--aside--YU9gb";
export var bottom = "aside-panel-module--bottom--CyHGI";
export var fixed = "aside-panel-module--fixed--fOcQ5";
export var panel = "aside-panel-module--panel--fQ3JE";
export var panelWithTopBanner = "aside-panel-module--panel-with-top-banner--jNlWZ";